import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setMotor, clearMotor } from "../actions";
import TextField from "@mui/material/TextField";
import CallToActionButton from "~components/styled/callToActionButton/CallToActionButton";
import Link from "@mui/material/Link";
import { makeStyles } from "@mui/styles";
import pxToRem from "~libs/pxToRem";
import PrimaryTitle from "~styled/primaryTitle/PrimaryTitle";
import MulticotizadorContent from "./MulticotizadorContent";

import { Typography, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ENTER_KEY = 13;

const useStyles = makeStyles((theme) => ({
  secondaryText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: pxToRem(16),
    fontWeight: "bold",
    lineHeight: "1.36",
    textAlign: "left",
    color: "#7644c9",
  },
  text: {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1.38,
    color: "#616161",
  },
  infoContainer: {
    display: "flex",
    alignItems: "center",
    paddingTop: pxToRem(24),
  },
}));

const disableCode = true;

const MotorStep = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [motor, setCampoMotor] = useState("");

  const canContinue = motor.length > 0;

  useEffect(() => {
    dispatch(clearMotor());
  }, [dispatch]);

  const handleNext = (value: string) => {
    dispatch(setMotor({ value, selected: true }));
  };

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.keyCode === ENTER_KEY && canContinue) handleNext(motor);
  };

  return (
    <MulticotizadorContent>
      <PrimaryTitle
        label={"Ingresá el número de motor del vehículo"}
        marginBottom={60}
      />

      <TextField
        variant="standard"
        fullWidth={true}
        onKeyDown={onKeyDown}
        autoFocus
        onFocus={(event) => event.target.select()}
        value={motor}
        onChange={(event) => setCampoMotor(event.target.value.toUpperCase())}
      ></TextField>

      <div style={{ display: "flex" }}>
        <Typography className={classes.secondaryText}>
          <Link
            className={classes.secondaryText}
            style={{ marginLeft: 5, marginTop: 5 }}
            component="button"
            underline="always"
            onClick={() => {
              handleNext("");
            }}
          >
            Omitir este paso
          </Link>
        </Typography>
      </div>

      {!disableCode && (
        <div className={classes.infoContainer}>
          <IconButton>
            <InfoOutlinedIcon />
          </IconButton>

          <Typography className={classes.text}>
            Recorda que completando todos los pasos podras descargar generar el
            certificado.
          </Typography>
        </div>
      )}

      <div style={{ paddingTop: pxToRem(24) }}>
        <CallToActionButton
          disabled={!canContinue}
          label={"Continuar"}
          onClick={() => {
            handleNext(motor);
          }}
        />
      </div>
    </MulticotizadorContent>
  );
};

export default MotorStep;
